import App from 'app/app.js';
import 'app/store/UserProfileStore.js';
import 'app/store/SubjectStore.js';

function LoginPopupService(UserProfileStore, SubjectStore, $rootScope) {
  this.claimLoginPopup = window.claimLoginPopup;
  this.cartLoginPopup = window.cartLoginPopup;
  this.subjects = SubjectStore.getVerifiedAndJobSubjects();

  this.showClaimLoginPopup = function () {
    if (
      !UserProfileStore.isLoggedIn() &&
      this.claimLoginPopup &&
      this.subjects &&
      this.subjects.length === 1 &&
      !$rootScope.packagesLoginPopup
    ) {
      $rootScope.packagesLoginPopup = true;
      return true;
    }
    return false;
  };

  this.showCartLoginPopup = function () {
    if (
      !UserProfileStore.isLoggedIn() &&
      this.cartLoginPopup &&
      this.subjects &&
      this.subjects.length === 1 &&
      !$rootScope.cartLoginPopup
    ) {
      $rootScope.cartLoginPopup = true;
      return true;
    }
    return false;
  };
}

App.service('LoginPopupService', ['UserProfileStore', 'SubjectStore', '$rootScope', LoginPopupService]);
